export default {
  meta: {
    title: '踩点报告详情',
    parentPath: ['/footprinting'],
    url: '/footprinting/review', // 埋点用，记录所属模块
    breadcrumbs: {
      path: ['/footprinting/review'],
      name: ['踩点分析报告'],
    },
  },
};
